<template>
  <div class="move">
    <van-nav-bar :title="this.videoInfo.vod_name">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>

    <!-- <Mydplayer :url="nowPlayVideoUrl" :pic='cover' /> -->

    <div class="movie-video">
      <d-player
        v-if="options.video.url"
        ref="player"
        class="player"
        @play="handlePlay"
        @pause="handlePause"
        :options="options"
      ></d-player>
    </div>

    <div class="title">
      <p>
        {{ this.videoInfo.vod_name }}
      </p>
      <span>
        {{ this.videoInfo.count }}{{ $t('video.bofangliang') }}
      </span>
    </div>
    <div class="item">
      <div class="title">
        <span>
          <i>
            <img
              src="data:image/png;base64,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"
              alt="">
          </i>
          {{ $t('video.hotlist') }}
        </span>
      </div>
      <div class="van-pull-refresh">
        <div class="van-pull-refresh__track" style="transition-duration: 0ms;">
          <div class="van-pull-refresh__head"></div>
          <div role="feed" class="van-list" aria-busy="true">
            <ul class="hot">
              <li @click="toPlayVideo(v.id)" v-for="(v, key) in moreVideoInfo" :key="key">
                <img :src="v.vod_pic" alt="">
                <div>
                  <span>
                    {{ v.vod_name }}
                  </span>
                  <span>
                    {{ $t('video.bofangliang') }}:{{ v.count }}
                  </span>
                </div>
              </li>
            </ul>
            <div class="van-list__placeholder"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Mydplayer from '../../common/Mydplayer'
// import DPlayer from "dplayer";

export default {
  // components: {
  //   Mydplayer
  // },
  data() {
    return {
      nowPlayVideoUrl: "",
      cover: "",
      userInfo: [],
      videoInfo: {},
      moreVideoInfo: {},
      player: null,
      is_zz: false,
      options: {
        mutex: false, //  防止同时播放多个用户，在该用户开始播放时暂停其他用户
        theme: "#b7daff", // 风格颜色，例如播放条，音量条的颜色
        loop: false, // 是否自动循环
        autoplay: false,
        lang: "zh-cn", // 语言，'en', 'zh-cn', 'zh-tw'
        screenshot: false, // CORS host blocks poster when screenshot is enabled
        hotkey: true, // 是否支持热键，调节音量，播放，暂停等
        preload: "auto", // 自动预加载
        volume: 0.7, // 初始化音量
        playbackSpeed: [0.5, 0.75, 1, 1.25, 1.5, 2, 3], //可选的播放速度，可自定义
        logo: "", // 在视频左上角上打一个logo
        video: {
          url: '', // 播放视频的路径
          pic: "",
          thumbnails: "" // 进度条上的缩略图,需要通过dplayer-thumbnails来生成
        },
      }
    };
  },
  methods: {
    back() {
      this.$router.push({ path: 'Home' })
    },
    getVideoInfo() {
      this.$http({
        method: 'get',
        data: { id: this.$route.query.id },
        url: 'video_get_info'
      }).then(res => {
        this.videoInfo = res.data;
        this.nowPlayVideoUrl = this.videoInfo.vod_play_url;
        this.options.video.pic = this.videoInfo.vod_pic;
        this.options.video.url = this.videoInfo.vod_play_url;
        this.$nextTick(() => {
          this.syncPlayer();
        });
        // this.cover = this.videoInfo.vod_pic;
        // let videos = document.getElementById('my-video');
        // videos.poster = this.cover;
        // this.getVideo();
      })

    },
    handlePlay() {
      console.log('播放');
      this.is_zz = true
    },
    handlePause() {
      console.log('暂停');
    },
    syncPlayer() {
      const playerRef = this.$refs.player;
      const dp = playerRef && playerRef.dp;
      if (!dp || !this.options.video.url) {
        return;
      }

      dp.switchVideo({
        url: this.options.video.url,
        pic: this.options.video.pic
      });
    },
    toPlayVideo(id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/Login' })
      } else {
        this.$router.push({ path: '?id=' + id })
        location.reload();
      }

    },
    getMoreVideoItem() {
      this.$http({
        method: 'get',
        url: 'video_get_more_item'
      }).then(res => {
        this.moreVideoInfo = res.data;
      })
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t('accountOffline'));
            localStorage.clear()
            this.$router.push({ path: '/Login' })
          } else {
            if (this.$store.getters.getBaseInfo.isplay == 1) {
              this.getVideoInfo();
              this.getMoreVideoItem()
              if (this.userInfo.money <= "0.00") {
                this.$toast(this.$t('video.plsrefisrt'));
                this.$router.push({ path: '/Home' })
              }
            } else {
              this.getVideoInfo();
              this.getMoreVideoItem();
            }
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' })
    } else {
      this.getUserInfo();
    }
  },
  destroyed() {
    const playerRef = this.$refs.player;
    const dp = playerRef && playerRef.dp;
    if (dp) {
      dp.destroy();
    }
  }
};
</script>

<style scoped>
.van-nav-bar {
  z-index: 999;
  background: url(/img/header.svg) no-repeat 50%/100%;
  line-height: 2.2rem;
}

.van-nav-bar {
  position: relative;
  z-index: 999;
  height: 3rem;
  line-height: 3rem;
  background: url(/img/header.svg) no-repeat 50%/100%
}

.van-nav-bar .van-icon,
.van-nav-bar__title {
  color: #fff
}

.dplayer-bezel .dplayer-bezel-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -3.467vw 0 0 -3.467vw;
  height: 16.933vw;
  width: 16.933vw;
  padding: 1.6vw;
  box-sizing: border-box;
  background: rgba(0, 0, 0, .5);
  border-radius: 50%;
  opacity: 0;
  pointer-events: none;
}

:export {
  gbcolor: linear-gradient(30deg, #7d76ef, #d63f8c)
}

.video-js {
  width: 100%;
  /*height: 420px;*/
  font-size: 24px;
}

.hot {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap
}

.hot li {
  width: calc(50% - .33333rem);
  border-radius: .33333rem;
  overflow: hidden;
  margin-top: .66667rem;
  height: 6.66667rem;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center
}

.hot li img {
  height: 100%;
  width: 100%;
}

.hot li>div {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, .4);
  padding: .33333rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center
}

.hot li>div span {
  color: #fff;
  font-size: .8rem;
  width: 50%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 .33333rem
}

:export {
  gbcolor: linear-gradient(30deg, #7d76ef, #d63f8c)
}

.move {
  width: 100%;
  min-height: 100%;
  background: #f0f0f0
}

.move .van-popup--top {
  top: 0;
  bottom: 0;
  margin: auto;
  background: none;
  display: flex;
  justify-content: center;
  align-items: center
}

.move .van-popup--top .box {
  width: 90%;
  height: 200px;
  background: #fff;
  border-radius: 10px;
  overflow: hidden
}

.move .van-popup--top .box .title {
  background: linear-gradient(30deg, #7d76ef, #d63f8c);
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  padding: 4% 5%
}

.move .van-popup--top .box .title p {
  font-size: 16px
}

.move .van-popup--top .box .title i {
  color: #fff
}

.move .van-popup--top .box .content h1 {
  font-size: 18px;
  padding: 30px 0
}

.move .van-popup--top .box .content a {
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
  color: #fff;
  padding: 10px 20px;
  border-radius: 90px;
  font-size: 12px
}

.move .van-popup--top .box .content p {
  padding: 20px 0
}

.move .van-popup--top .box .content p span {
  color: red
}

.move .d-player-video-main {
  width: 96% !important;
  height: auto !important
}

.movie-video {
  position: relative;
  z-index: 2;
}

.movie-video .dplayer-controller,
.movie-video .dplayer-controller .dplayer-icons {
  pointer-events: auto;
}

.movie-video .dplayer-mask {
  pointer-events: none;
}

::v-deep .dplayer-playing .dplayer-poster,
::v-deep .dplayer-playing .dplayer-bezel,
::v-deep .dplayer-playing .dplayer-bezel-icon {
  opacity: 0 !important;
}

.move .d-player-wrap {
  height: auto
}

.move>.title {
  background: #fff;
  width: 100%;
  padding: .66667rem 3%;
  text-align: left
}

.move>.title> {
  padding: 0 0
}

.move>.title p {
  font-weight: 600;
  color: #3e2186;
  font-size: .93333rem;
  margin-bottom: .5rem
}

.move>.title span {
  color: #aa2ddc;
  font-size: .8rem;
  background: #f2f2f5;
  padding: .33333rem .6rem;
  border-radius: .33333rem
}

.move .item {
  width: 100%;
  padding: .66667rem
}

.move .item>.title {
  display: flex;
  justify-content: space-between;
  align-items: center
}

.move .item>.title span {
  font-weight: 600;
  display: flex;
  font-size: 1rem;
  justify-content: flex-start;
  align-items: center;
  color: #4b358b
}

.move .item>.title span i {
  margin-right: .4rem
}

.move .item>.title span i img {
  width: 1.13333rem
}

.move .item>.title a {
  color: #979799
}

.poster {
  height: 13.33333rem;
  background: #000;
  position: relative
}

.poster>div,
.poster {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center
}

.poster>div {
  position: absolute;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, .8)
}

.poster>div .van-loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center
}

.poster img {
  height: 100%
}
</style>